import React, { Component, useEffect } from "react";

import { Col, Row, Alert, Button } from "react-bootstrap";
import { graphql, Query, compose } from "react-apollo";
import ValidatedRegisterForm from "../components/ValidatedRegisterForm";
import WrappedUp from "../containers/WrappedUp";
import AccountList from "../components/AccountList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faRemove,
  faWarning,
  faCheckCircle
} from "@fortawesome/free-solid-svg-icons";
import {
  getGoogleLink,
  getGoogleToken,
  getGoogleSheetsStatus
} from "../../api/queries/comptes.queries";
import { logout, useAuthDispatch, useAuthState } from "../Context";
import { useNavigate, useParams } from "react-router-dom";
import { getComptes } from "../../api/queries/comptes.queries";
import { toggleSheetsCompte } from "../../api/queries/comptes.mutations";
import { disableSheets } from "../../api/queries/comptes.mutations";
import { notify } from "../generic";
import Loader from "../components/Loader";

function SheetsPage(props) {
  const authContext = useAuthState(); //read user de
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();
  const { userDetails = {} } = authContext;
  const { id: utilisateurId, login, email, token } = userDetails;
  const queryParams = new URLSearchParams(window.location.search);
  const code = queryParams.get("code") || null;

  let display = null;

  const _mutateToggleSheetsCompte = async ({
    utilisateurId,
    identifiant,
    refetchAction
  }) => {
    try {
      return props
        .toggleSheetsCompte({
          variables: {
            utilisateurId,
            identifiant
          },
          refetchQueries: [
            {
              query: getComptes,
              variables: {
                utilisateurId
              }
            }
          ]
          // refetchQueries, optimisticResponse?
        })
        .then(({ data }) => {
          const { type, message, details } = data.toggleSheetsCompte;

          if (type === "success") {
            notify("success", message);
            refetchAction();
          } else {
            notify("error", message);
          }
        });
    } catch (error) {
      notify("error", error.message);
    }
  };

  const handleDisableSheets = ({ utilisateurId, refetchAction }) => {
    try {
      return props
        .disableSheets({
          variables: {
            utilisateurId
          },
          refetchQueries: [
            {
              query: getComptes,
              variables: {
                utilisateurId
              }
            }
          ]
          // refetchQueries, optimisticResponse?
        })
        .then(({ data }) => {
          const { type, message, details } = data.disableSheets;

          if (type === "success") {
            notify("success", message);
            refetchAction();
          } else {
            notify("error", message);
          }
        });
    } catch (error) {
      notify("error", error.message);
    }
  };

  function handleToggleAccount({ utilisateurId, identifiant, refetchAction }) {
    if (utilisateurId && identifiant)
      _mutateToggleSheetsCompte({ utilisateurId, identifiant, refetchAction });
  }

  return (
    <Query query={getGoogleSheetsStatus} variables={{ utilisateurId }}>
      {({
        loading: preLoading,
        error: preError,
        data: preData = {},
        refetch
      }) => {
        if (preLoading) return <Loader />;
        const { getGoogleSheetsStatus } = preData;
        const { type: googleSheetsStatus, details } = getGoogleSheetsStatus;

        const parsedDetails = JSON.parse(details);

        if (googleSheetsStatus === "success") {
          console.log({ parsedDetails });
          display = (
            <>
              <h2>Liste des comptes connectés</h2>
              <p>
                Vous pouvez cocher/décocher les comptes pour ajuster leur
                synchronisation sur Google Sheets
              </p>
              <p>
                {" "}
                <FontAwesomeIcon icon={faWarning} size="sm" />
                &nbsp; <strong>Note</strong> : Lorsque vous ajoutez un compte,
                vous devrez patienter quelques minutes avant que les données ne
                soient récupérées sur votre onglet sheets.
              </p>
              <a
                className="btn btn-cta"
                target="_blank"
                href={parsedDetails.googleUri}
              >
                <FontAwesomeIcon size="lg" icon={faFileExcel} />
                &nbsp; Accéder au sheets
                <div className="btn-cta-overlay"></div>
              </a>

              <AccountList
                configurable
                clickAction={handleToggleAccount}
                checkedCondition="sheetsActive"
              />

              <hr />
              <a
                className="btn btn-warning"
                onClick={() =>
                  handleDisableSheets({ utilisateurId, refetchAction: refetch })
                }
              >
                {" "}
                <FontAwesomeIcon size="lg" icon={faRemove} /> Supprimer ma
                connexion sheets
              </a>
            </>
          );
        }

        if (!code && googleSheetsStatus !== "success")
          display = (
            <Query query={getGoogleLink} variables={{ utilisateurId }}>
              {({ loading, error, data = {}, refetch }) => {
                if (loading) return <Loader />;
                const { getGoogleLink = { url: "" } } = data;
                const { url } = getGoogleLink;

                if (!url) return null;
                return (
                  <a className="btn btn-cta" href={url}>
                    <FontAwesomeIcon size="lg" icon={faFileExcel} />
                    &nbsp; Connecter à Google Sheets
                    <div className="btn-cta-overlay"></div>
                  </a>
                );
              }}
            </Query>
          );

        if (code && googleSheetsStatus !== "success") {
          display = (
            <Query query={getGoogleToken} variables={{ code, utilisateurId }}>
              {({ loading, error, data = {}, refetch }) => {
                if (loading) return <Loader />;
                const { getGoogleToken = { token: "" } } = data;
                const { token } = getGoogleToken;

                if (!token) return "Une erreur est survenue";
                // Une fois le token validé, on va afficher les comptes quand même

                return (
                  <div>
                    <h2>Succès !</h2>
                    <p>
                      Vos comptes ont bien été associé à votre compte Google !
                      <br />
                      Veuillez continuer sur la page suivante :
                    </p>
                    <a className="btn btn-cta" href="/sheets">
                      <FontAwesomeIcon size="lg" icon={faCheckCircle} />
                      &nbsp; Continuer
                      <div className="btn-cta-overlay"></div>
                    </a>
                  </div>
                );
              }}
            </Query>
          );
        }

        return <WrappedUp>{display}</WrappedUp>;
      }}
    </Query>
  );
}

export default compose(
  graphql(toggleSheetsCompte, {
    name: "toggleSheetsCompte"
  }),
  graphql(disableSheets, {
    name: "disableSheets"
  })
)(SheetsPage);
